import React from 'react';
import {NavLink} from "react-router-dom";

NotFound.propTypes = {};

function NotFound() {
    return (
        <div className="container">
            <div className="error404">
                <strong>Not Found</strong>
                <p>
                    The page you are looking for does not exist. You may have used an outdated link or may have typed
                    the URL incorrectly.
                </p>


                <NavLink
                    to="/"
                    title="Back to home"
                    className="btn btn-primary"

                >
                    Back to home ▸
                </NavLink>
            </div>
        </div>
    );
}

export default NotFound;
